import { render, staticRenderFns } from "./TagSearchField.vue?vue&type=template&id=08c98e4f"
import script from "./TagSearchField.vue?vue&type=script&lang=ts"
export * from "./TagSearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports